<div class="modal-header">
  <h5 class="modal-title">{{ titleKey | translate }}</h5>
  <button (click)="modal.dismiss()" class="close" tabindex="-1" type="button">
    <span class="icofont icofont-ui-close"></span>
  </button>
</div>
<div class="modal-body" style="white-space: pre-line">
  <ng-container *ngIf="messageTemplate; else textBody">
    <ng-container *ngTemplateOutlet="messageTemplate"></ng-container>
  </ng-container>
  <ng-template #textBody>{{ messageKey | translate }}</ng-template>
</div>
<div class="modal-footer">
  <button (click)="modal.dismiss()" class="btn btn-primary" type="button">
    {{ cancelKey | translate }}
  </button>
  <button (click)="modal.close(true)" class="btn btn-danger" type="button">
    {{ confirmKey | translate }}
  </button>
</div>
